<template>
    <div class="lesson-tab flex flex-col justify-center text-center mt-8 text-black">
      <slot></slot>
    </div>
</template>

<script>

export default {
  components: {
  },
  methods: {
  }
}
</script>

<style>
.lesson-tab {
  min-height: 400px;
}
</style>
